import { useEffect, useState } from "react";
import { getAllActivities } from "../../../../../API/Mediatheque/ActivityReports/activityService";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { ActivityReportData } from "../../../../../components/tables/activity-report-tables/ActivityReport";

const breadcrumbItems = [
  {
    title: "Rapports d'activité",
    link: "/admin-dashboard/mediatheque/rapports-activites",
  },
];
export default function ActivityReport() {
  const [activities, setActivities] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllActivities();
    setActivities(response?.activities);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <ActivityReportData data={activities} />
        </div>
      </div>
    </>
  );
}
